import React from 'react';
import { Link } from 'react-router-dom';
import MainLayout from '../layouts/MainLayout';
import SEOHead from '../components/SEOHead';
import { MEDIA_ASSETS } from '../utils/mediaAssets';

const GetInvolvedPage = () => {
  const scrollToNewsletter = () => {
    const element = document.getElementById('newsletter-section');
    const elementPosition = element.offsetTop;
    const headerHeight = 80; // Approximate header height
    const offsetPosition = elementPosition - headerHeight;

    window.scrollTo({
      top: offsetPosition,
      behavior: 'smooth'
    });
  };

  return (
    <MainLayout newsletterId="newsletter-section">
      <SEOHead 
        title="Включете се - Refresh Bulgaria"
        description="Станете част от нашата общност на доброволци! Включете се в акции за почистване, абонирайте се за новини или направете дарение за по-чиста България."
        keywords="доброволчество България, включване екология, дарения околна среда, volunteer Bulgaria environment"
        url="https://refreshbulgaria.com/get-involved"
      />
      <div className="max-w-screen-xl mx-auto px-4">
        <main className="mt-4">
          {/* Hero section */}
          <section className="mb-8">
            <div className="relative w-full h-64 md:h-80 rounded-lg overflow-hidden mb-6">
              <img 
                src={MEDIA_ASSETS.getInvolvedHeroImage} 
                alt="Присъединете се към Refresh Bulgaria - доброволчески акции за по-чиста България" 
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center">
                <div className="text-center text-white p-6">
                  <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold mb-4">
                    <span className="text-green-300">Включете се</span> в промяната
                  </h1>
                  <p className="text-base md:text-xl font-semibold opacity-90 max-w-2xl">
                    Заедно можем да направим България по-чиста
                  </p>
                </div>
              </div>
            </div>
          </section>

          {/* Join Our Cleanups Section */}
          <section className="mb-8">
            <div className="bg-white rounded-lg shadow-md overflow-hidden">
              <div className="bg-gradient-to-r from-green-700 to-green-600 p-6 text-white">
                <h2 className="text-2xl font-bold flex items-center">
                  <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0zm6 3a2 2 0 11-4 0 2 2 0 014 0zM7 10a2 2 0 11-4 0 2 2 0 014 0z" />
                  </svg>
                  Присъединете се към нашите акции
                </h2>
                <p className="text-green-100 mt-2">Най-директният начин да направите разликата</p>
              </div>
              
              <div className="p-6">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                  <div>
                    <p className="text-gray-700 mb-6 text-lg leading-relaxed">
                      Нашите доброволчески акции за почистване са отворени за всички, независимо от възраст или опит. 
                      Всеки може да направи разликата!
                    </p>
                    
                    <div className="space-y-4 mb-6">
                      <div className="flex items-start">
                        <div className="bg-green-100 rounded-full p-2 mr-4 mt-1">
                          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                          </svg>
                        </div>
                        <div>
                          <h4 className="font-semibold text-green-800 mb-1">Следете събитията</h4>
                          <p className="text-gray-600">Проверявайте редовно нашата страница за нови акции</p>
                        </div>
                      </div>
                      
                      <div className="flex items-start">
                        <div className="bg-green-100 rounded-full p-2 mr-4 mt-1">
                          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                          </svg>
                        </div>
                        <div>
                          <h4 className="font-semibold text-green-800 mb-1">Поканете приятели</h4>
                          <p className="text-gray-600">Споделете събитието с близки - заедно е по-забавно и ефективно</p>
                        </div>
                      </div>
                      
                      <div className="flex items-start">
                        <div className="bg-green-100 rounded-full p-2 mr-4 mt-1">
                          <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                          </svg>
                        </div>
                        <div>
                          <h4 className="font-semibold text-green-800 mb-1">Елате подготвени</h4>
                          <p className="text-gray-600">Носете удобни дрехи - ние осигуряваме материалите</p>
                        </div>
                      </div>
                    </div>
                    
                    <Link 
                      to="/events" 
                      className="inline-flex items-center bg-green-700 hover:bg-green-600 text-white font-semibold py-3 px-6 rounded-lg transition-colors duration-300"
                    >
                      Вижте предстоящи събития
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 ml-2" viewBox="0 0 20 20" fill="currentColor">
                        <path fillRule="evenodd" d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
                      </svg>
                    </Link>
                  </div>
                  
                  <div className="relative">
                    <div className="w-full h-64 lg:h-full rounded-lg overflow-hidden">
                      <img 
                        src={MEDIA_ASSETS.volunteersImage} 
                        alt="Доброволци в действие" 
                        className="w-full h-full object-cover hover:scale-105 transition-transform duration-300"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Stay in the Loop Section */}
          <section className="mb-8">
            <div className="bg-white rounded-lg shadow-md">
              <div className="p-6">
                <div className="flex items-center mb-4">
                  <div className="bg-green-100 p-3 rounded-full mr-4">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8 text-green-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                    </svg>
                  </div>
                  <div>
                    <h2 className="text-2xl font-bold text-green-800">Бъдете информирани</h2>
                    <p className="text-gray-600">Никога не пропускайте нашите събития и инициативи</p>
                  </div>
                </div>
                
                <div className="bg-green-50 p-6 rounded-lg mb-6">
                  <h3 className="font-semibold text-green-800 mb-4">С нашия бюлетин ще получавате:</h3>
                  <div className="grid md:grid-cols-2 gap-4">
                    <div className="flex items-center">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-green-600 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                      </svg>
                      <span className="text-gray-700">Напомняния за акции</span>
                    </div>
                    <div className="flex items-center">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-green-600 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M19 20H5a2 2 0 01-2-2V6a2 2 0 012-2h10a2 2 0 012 2v1m2 13a2 2 0 01-2-2V7m2 13a2 2 0 002-2V9a2 2 0 00-2-2h-2m-4-3H9M7 16h6M7 8h6v4H7V8z" />
                      </svg>
                      <span className="text-gray-700">Екологични новини</span>
                    </div>
                    <div className="flex items-center">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-green-600 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                      </svg>
                      <span className="text-gray-700">Истории за успех</span>
                    </div>
                    <div className="flex items-center">
                      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-green-600 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
                      </svg>
                      <span className="text-gray-700">Съвети за устойчивост</span>
                    </div>
                  </div>
                </div>
                
                <div className="text-center">
                  <button 
                    onClick={scrollToNewsletter} 
                    className="inline-flex items-center bg-green-700 hover:bg-green-600 text-white font-semibold py-3 px-8 rounded-lg transition-colors duration-300"
                  >
                    Абонирайте се сега
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 ml-2" viewBox="0 0 20 20" fill="currentColor">
                      <path fillRule="evenodd" d="M10.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L12.586 11H5a1 1 0 110-2h7.586l-2.293-2.293a1 1 0 010-1.414z" clipRule="evenodd" />
                    </svg>
                  </button>
                </div>
              </div>
            </div>
          </section>

          {/* Support Us with a Donation Section */}
          <section className="mb-8">
            <div className="bg-gradient-to-br from-green-700 to-green-800 rounded-lg text-white overflow-hidden">
              <div className="p-6 md:p-8">
                <div className="flex items-center mb-6">
                  <div className="bg-white bg-opacity-20 p-3 rounded-full mr-4">
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                    </svg>
                  </div>
                  <div>
                    <h2 className="text-2xl font-bold">Подкрепете нашата мисия</h2>
                    <p className="text-green-100">Всяко дарение прави разликата</p>
                  </div>
                </div>
                
                                 <div className="text-center mb-6">
                   <p className="text-green-100 mb-4 leading-relaxed text-lg">
                     Не можете да участвате физически? Можете да помогнете и по друг начин. 
                     Вашето дарение ни помага да закупим материали за почистване, да популяризираме събития и да разширим нашите усилия за по-чиста България.
                   </p>
                 </div>
                
                <div className="text-center">
                  <a 
                    href="https://www.paypal.com/donate/?hosted_button_id=WRAX5VQQ7TZ4U" 
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex items-center bg-white text-green-700 hover:bg-green-50 font-semibold py-4 px-8 rounded-lg transition-colors duration-300 text-lg"
                  >
                    <svg xmlns="http://www.w3.org/2000/svg" className="h-6 w-6 mr-3" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z" />
                    </svg>
                    Направете дарение
                  </a>
                </div>
              </div>
            </div>
          </section>
        </main>
      </div>
    </MainLayout>
  );
};

export default GetInvolvedPage; 